import React from 'react';
import IIconSvg from './IIconSvg';
import Svg from '../Svg';

const Add: React.FC<IIconSvg> = ({ fill = 'none', stroke = 'white', bgColor, size }) => (
  <Svg fill={fill} bgColor={bgColor} size={size} path="" viewBox="0 0 20 20">
    <path d="M10 4.16406V15.8307" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.16675 10H15.8334" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export default Add;
